import { render } from "./AthleteForms.vue?vue&type=template&id=52219190"
import script from "./AthleteForms.vue?vue&type=script&lang=js"
export * from "./AthleteForms.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__